module.exports = __webpack_public_path__ + "static/media/CC20-AP080-12.7abea8d8.png";